
(function(){
// No need for lookup service here, it resides in common folder
    angular.module('tmx-app').factory('LookupManagementService', ['$mdMedia','tmxResource',

        function LookupManagementService($mdMedia,tmxResource){


            var Lookups = tmxResource("Lookup");
            Lookups.gridColumn = [

                {
                    field: "LookupType",
                    title: "Name",
                    type: "name",
                 
                    width:  $mdMedia('gt-sm')?'47%':'150px',
                    scrollable: false,
                    resizable: true,
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LookupManagementCtrl.isFiltered('LookupType')}\" >{{'Name'|translate}}<i class='fa fa-filter' ng-if='LookupManagementCtrl.isFiltered(\"LookupType\")' ></i></span>"
                },
                {
                    field: "UserEditable",
                    title: "Type",
                    type: "string",
                    maxlength:"20",
                    minlength:"3",
                    width:  $mdMedia('gt-sm')?'47%':'150px',
                    scrollable: false,
                    resizable: true,
                    search: false,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : LookupManagementCtrl.isFiltered('LookupCategory')}\" >{{'Type'|translate}}<i class='fa fa-filter' ng-if='LookupManagementCtrl.isFiltered(\"LookupCategory\")' ></i></span>"
                }
            ];

            Lookups.columns = angular.copy(Lookups.gridColumn);
            Lookups.columns.push(
                {
                    width:  $mdMedia('gt-sm')?'6%':'150px',
                }
            );

            Lookups.getLookupByType = function(type){
                return Lookups.getByAction("LookupByType/"+type,true);
            }

            Lookups.updateLookups = function(lookups){
                return Lookups.getByAction('UpdateBulkLookup',false,'put',lookups);
            }
            return Lookups;

        }
    ]);

})();